import apiClient from '../client';
import type { Notification, SendNotificationPayload } from '@/types';

const BASE = '/admin/notifications';

export const notificationsApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Notification[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Notification }>(`${BASE}/${id}`).then((r) => r.data.data),

  send: (payload: SendNotificationPayload) =>
    apiClient.post<{ data: Notification }>(BASE, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),
};

